import React from 'react';
import Router from 'react-router/lib/Router';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';
import Redirect from 'react-router/lib/Redirect';

import {history} from '~/store';
import * as urls from './urls';
import root from '../components/root';
import Dashboard from '~/components/Dashboard';
import search from '../components/search/search';
import Landing from '~/components/Landing';
import Directions from '~/components/Directions';
import LoadPage from '~/components/LoadPage';
import BrokerPage from '~/components/BrokerPage';
import BrokersCatalog from '~/components/BrokersCatalog';
import JobName from '~/components/pages/JobName';
import Alert from '~/components/Alert';
import AddAlert from '~/components/Alert/AddAlert';
import AlertList from '~/components/Alert/AlertList';
import UpdateAlert from '~/components/Alert/UpdateAlert';
import LoadsList from '~/components/Alert/LoadsList';
import UserAccount from '~/components/pages/UserAccount';
import PendingPayment from '~/components/pages/PendingPayment';
import Result from '~/components/pages/Result';

import FreeAccount from '~/components/pages/FreeAccount';
import FreeAccountProfile from '~/components/pages/FreeAccount/AccountProfile'
import MyAccount from '~/components/pages/MyAccount';
import AccountProfile from '~/components/pages/MyAccount/AccountProfile';
import MembershipManage from '~/components/pages/MyAccount/MembershipManage';
import PaymentHistory from '~/components/pages/MyAccount/PaymentHistory';
import PaymentSetting from '~/components/pages/MyAccount/PaymentSetting';
import BidVerify from '~/components/pages/MyAccount/BidVerfiy'


import MyLoads from '~/components/pages/MyLoads';
import MyCompany from '~/components/pages/MyCompany';
import CompanyBrokerPage from '~/components/pages/MyCompany/BrokerPage';

import PaymentProcess from '~/components/pages/PaymentProcess';
import BasicInformation from '~/components/pages/PaymentProcess/BasicInformation';
import SelectProduct from '~/components/pages/PaymentProcess/SelectProduct';
import HpBillingInformation from '~/components/pages/PaymentProcess/HpBillingInformation';
import Payment from '~/components/pages/PaymentProcess/Payment';

import TOS from '~/components/pages/TOS';
import Privacy from '~/components/pages/Privacy';

import CreateAccount from '~/components/pages/CreateAccount';
import CreatePayment from '~/components/pages/CreateAccount/CreatePayment';
import CreatePendingPayment from '~/components/pages/CreateAccount/CreatePendingPayment';
import CreatePaymentResult from '~/components/pages/CreateAccount/CreatePaymentResult';

import RateCheck from '~/components/rate/rateCheck';
import RateInspection from '~/components/rate/rateInspection';
import LoadRatio from '~/components/rate/loadRatio';
import Calculator from '~/components/rate/calculator';
import AddressAndEqipInfo from '~/components/rate/AddressAndEqipInfo';
// import CapacityRatio from '~/components/CapacityRatio'
import CapacityRatio from "../pages/CapacityRatio";
import PostTruck from '../pages/PostTruck'

import WelcomeProcess from '~/components/pages/MyAccount/WelcomeProcess'
import WelcomeBackProcess from '~/components/pages/MyAccount/Welcomeback-process'
import UserDispatcher from '~/components/pages/UserDispatcher';

import UploadW9Anon from '~/components/pages/UploadW9Anon';
import LoadsmartUpload from '~/components/pages/LoadsmartUpload';
import EmailCampaign from '~/pages/EmailCampaign';

import MessagePush from '~/pages/MessagePush';
import MemberShip from '~/components/pages/MemberShip';
import OrderPage from '~/components/pages/MemberShip/OrderPage';
import EmailCampaignNew from '~/pages/EmailCampaignNew';
import SimplePayment from '~/pages/Payment'
import RatioMapList from '~/pages/CapacityRatio/compontents/RatioMapList';
import MembershipPlans from '~/pages/MembershipPlans'

import FuelSurcharge from '~/pages/FuelSurchargePage';
export default (
  <Router history={history}>
    <Route path='/' component={root}>
      <IndexRoute component={Dashboard}/>

      <Route path={`${urls.LOADS}/:id`} component={LoadPage}/>
      <Route path={`${urls.LOADS}/:id/:location`} component={LoadPage}/>
      <Route path={`${urls.BROKERS}/:DOT`} component={BrokerPage}/>
      <Route path={`${urls.MYCOMPANY}/:DOT`} component={CompanyBrokerPage}/>
      <Route path={`${urls.SEARCHLOADS}/*`} component={search}/>
      <Route path={urls.SEARCHLOADS} component={search}/>
      <Route path={urls.LOADS} component={search}/>

      <Redirect from='/dashboard' to='/' />
      <Redirect from='/trucks' to='/' />
      <Route path={urls.LANDING} component={Landing}/>
      {/* <Route path={urls.DIRECTIONS} component={Directions}/> */}
      <Route path={urls.BROKERS} component={BrokersCatalog}/>
      <Route path={urls.JOBTITLE} component={JobName}/>
      <Route path={urls.ALERT} component={Alert}>
        <Route path={urls.ALERTURL.AddAlert} component={AddAlert}/>
        <Route path={urls.ALERTURL.AlertList} component={AlertList}/>
        <Route path={`${urls.ALERTURL.UpdateAlert}/:id`} component={UpdateAlert}/>
        <Route path={`${urls.ALERTURL.LoadsList}/:id/:equipment`} component={LoadsList}/>
      </Route>

      <Route path={urls.TOS} component={TOS}/>
      <Route path={urls.PRIVACY} component={Privacy}/>

      <Route path={urls.CREATEACCOUNT} component={CreateAccount}/>
      <Route path={urls.CreatePayment} component={CreatePayment}/>
      <Route path={urls.CreatePendingPayment} component={CreatePendingPayment}/>
      <Route path={urls.CreatePaymentResult} component={CreatePaymentResult}/>

      <Route path={urls.RATECHECK} component={RateCheck}/>
      <Route path={urls.FUELSURCHARGE} component={FuelSurcharge}/>

      <Route path={urls.INFO} component={AddressAndEqipInfo}>
        <Route path={urls.RATEINSPECTION} component={RateInspection}/>
        <Route path={urls.LOADRATIO} component={LoadRatio}/>
        <Route path={urls.CALCULATOR} component={Calculator}/>
      </Route>

      <Route path={urls.USERACCOUNT} component={UserAccount}/>
      <Route path={urls.FREEACCOUNT} component={FreeAccount}>
        <IndexRoute component={FreeAccountProfile}/>
        <Route path={urls.FREEACCOUNTURL.dotVerify} component={BidVerify}/>
      </Route>
      <Route path={urls.PendingPayment} component={PendingPayment}/>
      <Route path={urls.Result} component={Result}/>
      <Route path={urls.CAPACITYRATIO} component={CapacityRatio}/>
      <Route path={`${urls.CAPACITYRATIO}/*`} component={CapacityRatio}/>
      {/* <Route path={'/new-capacity-ratio'} component={CapacityRatio} /> */}
      <Route path={urls.MYCOMPANY} component={MyCompany} />
      <Route path={urls.MYLOADS} component={MyLoads} />
      <Route path={urls.POSTTRUCk} component={PostTruck} />
      <Route path={urls.WELCOMEPROCESS} component={WelcomeProcess} />
      <Route path={urls.WELCOMEBACKPROCESS} component={WelcomeBackProcess} />
      <Route path={urls.ACCOUNT} component={UserDispatcher} />
      <Route path={urls.UPLOADW9} component={UploadW9Anon} />
      <Route path={urls.UPLOADLOADSMART} component={LoadsmartUpload} />
      <Route path={urls.EMAILCAMPAIGN} component={EmailCampaign} />
      <Route path={urls.MESSAGE} component={MessagePush} />
      <Route path={urls.MEMBERSHIP} component={MemberShip} />
      <Route path={urls.CAPACITYRATIOMAPLIST} component={RatioMapList}/>
      <Route path={urls.ORDERPAGE} component={OrderPage} />
      <Route path={urls.EMAILCAMPAIGNNEW} component={EmailCampaignNew} />
      <Route path={urls.MYACCOUNT} component={MyAccount}>
        <IndexRoute component={AccountProfile}/>

        <Redirect from='/my-account/account-profile' to='/my-account' />
        <Route path={urls.MYACCOUNTURL.membershipManage} component={MembershipManage}/>
        <Route path={urls.MYACCOUNTURL.paymentHistory} component={PaymentHistory}/>
        <Route path={urls.MYACCOUNTURL.paymentSetting} component={PaymentSetting}/>
        <Route path={urls.MYACCOUNTURL.dotVerify} component={BidVerify}/>
      </Route>

      <Route path={urls.PAYMENT.paymentProcess} component={SimplePayment}>
        <IndexRoute component={BasicInformation} />
        <Redirect from='/hp/basic-information' to='/hp' />
        <Route path={urls.PAYMENT.ProductSelection} component={SelectProduct}/>
        <Route path={urls.PAYMENT.HpBillingInformation} component={HpBillingInformation}/>
        <Route path={urls.PAYMENT.Payment} component={Payment}/>
      </Route>

      <Route path={urls.MEMBERSHIPPLANS} component={MembershipPlans} />
    </Route>
  </Router>
);



// WEBPACK FOOTER //
// ./src/routing/routes.js